import React from 'react';
import { Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { FileTextOutlined, UserAddOutlined, EnvironmentOutlined, SettingOutlined } from '@ant-design/icons';


const Settings = () => {
    return (
        <div>
            <div className="flex items-center p-5 gap-2">
            <SettingOutlined className="text-2xl text-red-600" />
               <p className="text-md text-black font-bold"> Settings</p>
            </div>
            <div className="p-20">
            <Row gutter={[16, 16]}>

                {/* First Card: View Officers */}
                <Col xs={24} md={8}>
                    <Link to="/officers">
                    <Card
                    hoverable
                    className="bg-white shadow-lg hover:bg-red-600 hover:text-white transition-all duration-0 flex items-center justify-center"
                    style={{ height: '200px', padding: '24px' }}
                >
                    <div className="flex items-center gap-4">
                        <UserAddOutlined className="text-6xl" /> 
                                                <div>
                            <h2 className="text-xl font-bold transition-all">Reporting Officers</h2>
                            <p className="transition-all">  View and manage reporting officers.</p>
                        </div>
                    </div>
                </Card>
                    </Link>
                </Col>

                {/* Second Card: Assign Officer to Constituencies */}
                <Col xs={24} md={8}>
                    <Link to="/settings/assign-officer">
                    <Card
                    hoverable
                    className="bg-white shadow-lg hover:bg-red-600 hover:text-white transition-all duration-0 flex items-center justify-center"
                    style={{ height: '200px', padding: '24px' }}
                >
                    <div className="flex items-center gap-4">
                        <FileTextOutlined className="text-6xl" /> 
                        <div>
                            <h2 className="text-xl font-bold transition-all">Assign Officer to Constituencies</h2>
                            <p className="transition-all">Assign officers to constituencies.</p>
                        </div>
                    </div>
                </Card>
                    </Link>
                </Col>

                {/* Third Card: Constituencies */}
                <Col xs={24} md={8}>
                    <Link to="/settings/constituencies">
                    <Card
                    hoverable
                    className="bg-white shadow-lg hover:bg-red-600 hover:text-white transition-all duration-0 flex items-center justify-center"
                    style={{ height: '200px', padding: '24px' }}
                >
                    <div className="flex items-center gap-4">
                        <EnvironmentOutlined className="text-6xl" />
                        <div>
                            <h2 className="text-xl font-bold transition-all">Constituencies</h2>
                            <p className="transition-all"> List all constituencies.</p>
                        </div>
                    </div>
                </Card>
                    
                    </Link>
                </Col>
            </Row>
        </div>
        </div>
    );
};

export default Settings;